import * as Yup from 'yup';

import MessageComponent from './Components/Message';
import MessageField from './Components/MessageField';
import ContactGroups from './Components/ContactGroups';


const headers = [
  {
    label: 'Promotion ID',
    id: 'sms_promotion_id'
  },
  {
    label: "Description",
    id: "details"
  },
  {
    label: 'Customers',
    id: 'total_count'
  },
  {
    label: "Successful",
    id: "sent_count"
  },
  {
    label: "Failed",
    id: "failed_count"
  },
  {
    label: "Status",
    id: "status",
    multi: true,
    values: [{value: "sending", label: "In Progress", status: "warning"}, {value: "complete", label: "Completed", status: "success"}, {value: "failed", label: "Failed", status: "error"}]
  },
  {
    label: "Date",
    id: "created_at",
    date: true
  }
];

const filters = [
  {
    id: "date",
    type: "date",
    label: "Date",
  }
];


const fields = [
  {
    fieldType: "Component",
    Component: <MessageComponent />,
    name: "text",
    size: {xs: 12},
  },
  {
    fieldType: "Component",
    Component: <ContactGroups />,
    name: "contact_groups",
    size: {xs: 12},
  },
  { 
    fieldType: "formField",
    formFieldType: "text",
    name: "details",
    label: "Promotion Description (Optional)",
    type: "text",
    size: {xs: 12},
  },
  {
    fieldType: "Component",
    Component: <MessageField />,
    name: "message_field",
    size: {xs: 12},
  }
]

const initialValues = {
  details: '',
  text: '',
  // contact_group: ""
}

// The GSM-7 basic + extension set — the only chars carriers bill at the cheap rate.
const GSM7_CHARS = new Set([
  ..."@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !\"#¤%&'()*+,-./0123456789:;<=>?",
  ..."¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà",
  ..."^{}\\[~]|€",
]);

// Iterate by code point (...str) so an emoji counts as one character, not two broken halves.
const getInvalidChars = (str = "") => {
  const bad = [];
  for (const ch of str) {
    if (!GSM7_CHARS.has(ch)) bad.push(ch);
  }
  return [...new Set(bad)];
};

const schema = Yup.object().shape({
  text: Yup
    .string()
    .required("Message is required")
    .test("gsm7-only", function (value) {
      const bad = getInvalidChars(value);
      if (bad.length === 0) return true;
      return this.createError({
        message: `Unsupported character${bad.length === 1 ? '' : 's'}: ${bad.join(' ')} — emojis and special symbols are not supported. Please remove them.`,
      });
    })
});


export { fields, initialValues, schema, headers, filters 
  // parseData,
 };